/**
 * Created by li.zhixiong on 2018/3/21.
 */
import router from '../router'
import axios from 'axios'
import { ElMessage } from 'element-plus';
/*
import Vue from 'vue'
*/


let qs = require('qs')

const errInfoTips = (MessageType, Message) => {
  if (MessageType === '401') {
    router.push({path:'/'})
    window.localStorage.clear()
  } else if(MessageType.toString().slice(0,1) === '5'){
    ElMessage.error('服务器异常,请稍后再试！')
  }
}

let RequestMethod = {
  'GET': 'GET',
  'HEAD': 'HEAD',
  'POST': 'POST',
  'PUT': 'PUT',
  'PATCH': 'PATCH',
  'DELETE': 'DELETE',
  'DOWNLOADPOST': "DOWNLOADPOST",
  'DOWNLOAD': 'DOWNLOAD'
}

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (!config.headers.noToken && window.localStorage.shareui_token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = `${window.localStorage.shareui_token}`
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
const Utils = {
  httpUtil (url, data, config = {}, type) {
    // console.log(url, data, config, type)
    return new Promise((resolve, reject) => {
      let axiosTemp
      switch (type) {
        case RequestMethod.DELETE:
          axiosTemp = axios.delete(url, config)
          break
        case RequestMethod.HEAD:
          axiosTemp = axios.head(url, config)
          break
        case RequestMethod.PATCH:
          axiosTemp = axios.patch(url, data, config)
          break
        case RequestMethod.POST:
          axiosTemp = axios.post(url, data, config)
          break
        case RequestMethod.PUT:
          axiosTemp = axios.put(url, data, config)
          break
        case RequestMethod.DOWNLOAD:
          axiosTemp = axios.get(url, config);
          break;
        default:
          axiosTemp = axios.get(url, config)
      }
      axiosTemp.then(function (response) {
        let MessageType = response.data.code
        let Message = response.data.detail
        if (!MessageType || MessageType === '200' || MessageType===200) { // 成功
          resolve(response)
        } else {
          
          errInfoTips(MessageType, Message)
          resolve(response)
        }
      }).catch(function (error) {
        if(error.response.status === 401){
          console.log(401);
          router.push({path: '/'})
          window.localStorage.clear()
        }
        if (error && error.response && error.response.data) {
          let code = error.response.status;
          let message = error.response.statusText;
          errInfoTips(code, message);
          resolve(error.response);
        } else {
          reject(error);
        }
      })
    })
  },
  get (url, data = {}) {
    return Utils.httpUtil(url, null, {
      params: data,
      withCredentials: true
    }, RequestMethod.GET)
  },
  post (url, data = {}) {
    return Utils.httpUtil(url, qs.stringify(data), {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }, RequestMethod.POST)
  },

  postLogin (url, data = {}) {
    return Utils.httpUtil(
      url,
      null,
      {
        params: data,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          noToken: true,
          Authorization: 'Basic d2ViOjEyMzQ1Ng=='
        }
      },
      RequestMethod.POST
    )
  },
  getNoToken (url, data = {}) {
    return Utils.httpUtil(
      url,
      null,
      {
        params: data,
        withCredentials: true,
        headers: {
          noToken: true
        }
      },
      RequestMethod.GET
    )
  },
  postlogin (url, data = {}) {
    return Utils.httpUtil(url, qs.stringify(data), {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': 'Basic d2ViOjEyMzQ1Ng=='
      }
    }, RequestMethod.POST)
  },
  postJSON (url, data = {}) {
    return Utils.httpUtil(url, JSON.stringify(data), {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }, RequestMethod.POST)
  },
  postFile (url, data = {}) {
    return Utils.httpUtil(url, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }, RequestMethod.POST)
  },
  delete (url, data = {}) {
    return Utils.httpUtil(url, null, {
      params: data,
      withCredentials: true
    }, RequestMethod.DELETE)
  },
  put (url, data = {}) {
    return Utils.httpUtil(url, qs.stringify(data), {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }, RequestMethod.PUT)
  },
  putJSON (url, data = {}) {
    return Utils.httpUtil(url, JSON.stringify(data), {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }, RequestMethod.PUT)
  },
  // 在用axios，get一下这个json，build目錄下 webpack.prod.conf.js文件
  getConfigJson () {
    axios.get('serverconfig.json').then((result) => {
      console.log('read from json')
      console.log(result)
    }).catch((error) => {
      console.log(error)
    })
  },
  download(url, data = {}) {
    return Utils.httpUtil(
        url,
        null, {
          responseType: 'blob',
          params: data,
          withCredentials: false,
          headers: {
            noToken: true
          }
        },
        RequestMethod.DOWNLOAD
    );
  },
  downloadPOST(url, data = {}) {
    return Utils.httpUtil(
        url,
        qs.stringify(data), {
          responseType: 'blob',
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
          }
        },
        RequestMethod.POST
    );
  },
  patch (url, data = {}) {
    return Utils.httpUtil(url, qs.stringify(data), {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }, RequestMethod.PATCH)
  },
}
export default Utils
